import PropTypes from 'prop-types';

const TitleFooter = ({ answers, createdDatetime, narrativeName }) => {
  if (!narrativeName) return null;

  const type = `Narrative Type: ${narrativeName}`;
  const createdOn = createdDatetime ? ` | Created: ${createdDatetime}` : '';

  const subscribedChannels = answers?.subscribedChannels?.length
    ? answers.subscribedChannels.map((channel) => channel?.name)
    : [];

  return (
    <div>
      <p>
        <small>
          {type}
          {createdOn}
        </small>
      </p>
      {subscribedChannels.length > 0 && (
        <p>
          <small>Subscribed Channels: {subscribedChannels.join(', ')}</small>
        </p>
      )}
    </div>
  );
};

TitleFooter.propTypes = {
  answers: PropTypes.object,
  createdDatetime: PropTypes.string,
  narrativeName: PropTypes.string,
};

export default TitleFooter;
